import { render, staticRenderFns } from "./LicitacaoFornecedorAcoesParticipar.vue?vue&type=template&id=53b0f2ce"
import script from "./LicitacaoFornecedorAcoesParticipar.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorAcoesParticipar.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorAcoesParticipar.vue?vue&type=style&index=0&id=53b0f2ce&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports